import { defineMessage } from 'services/localization';

export const messages = {
    popupTitle: defineMessage('out_of_office'),
    setDelegateButton: defineMessage('set_a_substitute'),
    descriptionText: defineMessage('specify_the_substitutes_requests_on_your_behalf'),
    pleaseNoteText: defineMessage('important'),
    timezoneHintText: defineMessage('pleasenote_the_dates_yo_ayed_correctly_for_them'),
    companyColumnTitle: defineMessage('organisation'),
    delegateColumnTitle: defineMessage('substitute'),
    startDateColumnTitle: defineMessage('start_date'),
    endDateColumnTitle: defineMessage('end_date'),
    timeZone: defineMessage('time_zone'),
    delegatesSet: defineMessage('substitutes_were_set'),
    searchOrgPlaceholder: defineMessage('search_organisation'),
    required: defineMessage('field_is_required'),
    dateFromCantBeAfterDateTo: defineMessage('the_start_date_must_be_earlier_than_the_end_date'),
};
